import styled from "styled-components";
import { Div } from "../../../../common/ui/widgets";

export const EmptyView = styled(Div)`
  flex: 1;
  background: ${props => props.theme.brandWhite};
  align-items: center;
  height: ${props =>
    props.scrollHeight
      ? props.scrollHeight
      : props.expand
      ? ((props.uiconstants && props.uiconstants.expandedListMaxHeight) ||
          (props.uiConstants && props.uiConstants.expandedListMaxHeight) ||
          "inherit")
      : ((props.uiconstants && props.uiconstants.collapsedListMaxHeight) ||
          (props.uiConstants && props.uiConstants.collapsedListMaxHeight) ||
          "inherit")};
  color: ${props => props.theme.emptyViewColor};
  font-family: ${props => props.theme.font_family};
  font-size: ${props => props.theme.font14};
  font-weight: ${props => props.theme.fontWeight500};
  justify-items: center;
  font-family: ${props => props.theme.font_family};
  font-size: ${props => props.theme.font14};
  line-height: 17px;
  color: ${props => props.theme.emptyViewColor};
  margin-top: ${props => props.marginTop};
  padding-bottom: ${props => props.paddingBottom};
`;
